/**
 * Alert Banner Module
 * Wyzwalanie i zamykanie alert bannerów z animacjami
 *
 * Użycie:
 *   <div class="alert-banner alert-banner--default" data-auto-show>...</div>
 *   <div class="alert-banner alert-banner--error" data-auto-show data-auto-dismiss="5000">...</div>
 *
 * Popover (wrapper — banner obok triggera):
 *   <div class="alert-banner-popover">
 *     <button data-popover-trigger="popover-id">Toggle</button>
 *     <div class="alert-banner alert-banner--default alert-banner--popover" id="popover-id">...</div>
 *   </div>
 *
 * Popover (detached — banner gdziekolwiek w DOM, pozycja obliczana z JS):
 *   <button data-popover-trigger="popover-id">Toggle</button>
 *   <!-- gdziekolwiek w DOM -->
 *   <div class="alert-banner alert-banner--default alert-banner--popover" id="popover-id">...</div>
 *
 * API:
 *   AlertBanner.show(element)    — pokaż banner z animacją
 *   AlertBanner.dismiss(element) — ukryj banner z animacją
 */

(function () {
    'use strict';

    /**
     * Pokaż alert banner
     */
    function show(el) {
        if (!el) return;

        // Jeśli to popover — użyj logiki popover
        if (el.classList.contains('alert-banner--popover')) {
            showPopover(el);
            return;
        }

        el.style.display = '';
        el.classList.remove('is-dismissing');
        el.classList.add('is-visible');

        // Auto-dismiss jeśli ustawiony
        var autoDismiss = el.getAttribute('data-auto-dismiss');
        if (autoDismiss) {
            var delay = parseInt(autoDismiss, 10);
            if (!isNaN(delay) && delay > 0) {
                el._autoDismissTimer = setTimeout(function () {
                    dismiss(el);
                }, delay);
            }
        }
    }

    /**
     * Ukryj alert banner z animacją
     */
    function dismiss(el) {
        if (!el) return;

        // Wyczyść timer auto-dismiss
        if (el._autoDismissTimer) {
            clearTimeout(el._autoDismissTimer);
            el._autoDismissTimer = null;
        }

        el.classList.add('is-dismissing');

        el.addEventListener('animationend', function handler() {
            el.removeEventListener('animationend', handler);
            el.classList.remove('is-visible', 'is-dismissing');
            el.style.display = 'none';

            // Wyczyść pozycjonowanie popover
            if (el.classList.contains('alert-banner--popover')) {
                el.classList.remove('alert-banner--popover-top');
                // Reset inline styles dla detached popover
                if (el.classList.contains('alert-banner--popover-fixed')) {
                    el.style.top = '';
                    el.style.left = '';
                    el.style.bottom = '';
                    el.classList.remove('alert-banner--popover-fixed');
                }
                el._popoverTrigger = null;
            }
        });
    }

    // ----------------------------------------
    // POPOVER — logika pozycjonowania
    // ----------------------------------------

    /**
     * Pokaż popover banner z auto-pozycjonowaniem
     */
    function showPopover(el, triggerEl) {
        if (!el) return;

        // Zamknij inne otwarte popovery
        dismissAllPopovers(el);

        // Zapamiętaj trigger
        el._popoverTrigger = triggerEl || null;

        // Pozycjonowanie: sprawdź viewport
        positionPopover(el, triggerEl);

        el.style.display = '';
        el.classList.remove('is-dismissing');
        el.classList.add('is-visible');

        // Auto-dismiss jeśli ustawiony
        var autoDismiss = el.getAttribute('data-auto-dismiss');
        if (autoDismiss) {
            var delay = parseInt(autoDismiss, 10);
            if (!isNaN(delay) && delay > 0) {
                el._autoDismissTimer = setTimeout(function () {
                    dismiss(el);
                }, delay);
            }
        }
    }

    /**
     * Pozycjonowanie popovera
     * — Jeśli w wrapperze .alert-banner-popover → CSS absolute (jak dotąd)
     * — Jeśli detached (bez wrappera) → position: fixed + obliczone z triggerRect
     */
    function positionPopover(el, triggerEl) {
        var preferredPosition = el.getAttribute('data-popover-position') || 'bottom';
        var wrapper = el.closest('.alert-banner-popover');
        var GAP = 8; // px odstęp od triggera
        var estimatedHeight = 120;

        // Reset
        el.classList.remove('alert-banner--popover-top');

        // ---- TRYB WRAPPER (banner obok triggera w DOM) ----
        if (wrapper) {
            // Reset fixed styles jeśli były
            el.style.top = '';
            el.style.left = '';
            el.style.bottom = '';
            el.classList.remove('alert-banner--popover-fixed');

            if (preferredPosition === 'top') {
                el.classList.add('alert-banner--popover-top');
                return;
            }

            var wrapperRect = wrapper.getBoundingClientRect();
            var spaceBelow = window.innerHeight - wrapperRect.bottom;

            if (spaceBelow < estimatedHeight && wrapperRect.top > estimatedHeight) {
                el.classList.add('alert-banner--popover-top');
            }
            return;
        }

        // ---- TRYB DETACHED (banner gdziekolwiek w DOM) ----
        if (!triggerEl) return;

        el.classList.add('alert-banner--popover-fixed');
        var triggerRect = triggerEl.getBoundingClientRect();

        // Pozycja pozioma — wyrównaj do lewej krawędzi triggera
        var leftPos = triggerRect.left;
        // Nie wychodź poza prawy brzeg viewportu
        var popoverWidth = Math.min(400, window.innerWidth - 20);
        if (leftPos + popoverWidth > window.innerWidth - 10) {
            leftPos = window.innerWidth - popoverWidth - 10;
        }
        if (leftPos < 10) leftPos = 10;
        el.style.left = leftPos + 'px';

        // Pozycja pionowa — bottom/top/auto-flip
        var spaceBelow = window.innerHeight - triggerRect.bottom - GAP;
        var spaceAbove = triggerRect.top - GAP;
        var showOnTop = false;

        if (preferredPosition === 'top') {
            showOnTop = true;
        } else if (spaceBelow < estimatedHeight && spaceAbove > estimatedHeight) {
            showOnTop = true;
        }

        if (showOnTop) {
            el.classList.add('alert-banner--popover-top');
            el.style.top = 'auto';
            el.style.bottom = (window.innerHeight - triggerRect.top + GAP) + 'px';
        } else {
            el.style.top = (triggerRect.bottom + GAP) + 'px';
            el.style.bottom = 'auto';
        }
    }

    /**
     * Zamknij wszystkie otwarte popovery (oprócz wyjątku)
     */
    function dismissAllPopovers(except) {
        var openPopovers = document.querySelectorAll('.alert-banner--popover.is-visible');
        for (var i = 0; i < openPopovers.length; i++) {
            if (openPopovers[i] !== except) {
                dismiss(openPopovers[i]);
            }
        }
    }

    /**
     * Toggle popovera — pokaż/ukryj
     */
    function togglePopover(el, triggerEl) {
        if (!el) return;

        if (el.classList.contains('is-visible')) {
            dismiss(el);
        } else {
            showPopover(el, triggerEl);
        }
    }

    /**
     * Inicjalizacja
     */
    function init() {
        // Delegacja eventów — zamknięcie bannera
        document.addEventListener('click', function (e) {
            var closeBtn = e.target.closest('.alert-banner__close');
            if (closeBtn) {
                var banner = closeBtn.closest('.alert-banner');
                if (banner) {
                    dismiss(banner);
                }
                return;
            }

            // Popover trigger — toggle
            var trigger = e.target.closest('[data-popover-trigger]');
            if (trigger) {
                e.preventDefault();
                e.stopPropagation();
                var targetId = trigger.getAttribute('data-popover-trigger');
                var targetBanner = document.getElementById(targetId);
                if (targetBanner) {
                    togglePopover(targetBanner, trigger);
                }
                return;
            }

            // Click outside — zamknij otwarte popovery
            var insidePopover = e.target.closest('.alert-banner--popover');
            if (!insidePopover) {
                dismissAllPopovers();
            }
        });

        // Escape key — zamknij popovery
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                dismissAllPopovers();
            }
        });

        // Auto-show bannerów z data-auto-show
        var autoShowBanners = document.querySelectorAll('.alert-banner[data-auto-show]');
        for (var i = 0; i < autoShowBanners.length; i++) {
            show(autoShowBanners[i]);
        }
    }

    // Globalne API
    window.AlertBanner = {
        show: show,
        dismiss: dismiss,
        togglePopover: togglePopover,
        dismissAllPopovers: dismissAllPopovers
    };

    // Inicjalizacja po załadowaniu DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
